import { CREATE_SHELF_URL, DELETE_SHELF_URL, LIST_SHELF_URL, SHELF_LIST_DROPDOWN, SHELF_SINGLE_DETAIL } from "../api";
import axiosInstance from "../axiosInstance";

export const createShelf = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_SHELF_URL, props?.values)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listShelf = (props) => onResponse => {
    try {
        let BASE_URL = LIST_SHELF_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.sort) {
            BASE_URL += 'sort_by=' + props.sort + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const getSingleshelfDetail = (props) => onResponse => {
    try {
        let BASE_URL = SHELF_SINGLE_DETAIL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listshelfDropdown = (props) => onResponse => {
    try {
        let BASE_URL = SHELF_LIST_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.room_id) {
            BASE_URL += 'room_id=' + props.room_id + '&'
        }
         if (props.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });



    } catch (error) {

    }
}

export const deleteShelf = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_SHELF_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};
